"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useComparison = _interopRequireDefault(require("../../hooks/comparison/useComparison"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../services");
var _useConfig = _interopRequireDefault(require("../../hooks/useConfig"));
var _useLocalTheme = _interopRequireDefault(require("../../hooks/useLocalTheme"));
var _useRecommendationCosts = require("../../hooks/recommendation/useRecommendationCosts");
var _CustomIconOrImage = _interopRequireDefault(require("../shared/CustomIconOrImage"));
var _constants = require("../../utils/constants");
var _useRecommendationActions = require("../../hooks/recommendation/useRecommendationActions");
var _recommendationSelectors = require("../../store/recommendation/recommendationSelectors");
var _useAppSelector = require("../../hooks/useAppSelector");
var _useQuestionsMetadata = require("../../hooks/questionnaire/useQuestionsMetadata");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Container = _styledComponents.default.div`
  padding: 20px;
  border: solid 1px #bebebe;
  border-radius: 12px;
  margin: 24px 0px 0px 0px;
  ${_r10SourceLibrary.Mixins.respondTo.md(`padding: 24px;`)}
`;
const StyledContainerHeader = _styledComponents.default.div`
  display: flex;
  border-bottom: 1px solid #bebebe;
  justify-content: space-around;
`;
const CenteringWrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 16px 0;
`;
const StyledContainerBody = _styledComponents.default.div`
  display: flex;
  justify-content: space-around;
  gap: 10px;
  ${_r10SourceLibrary.Mixins.respondTo.md(`gap: 60px;`)}
`;
const PlanTitleContainer = _styledComponents.default.div`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  margin: 30px 0px 16px 0px;
  flex-direction: column;
  flex: 1;
`;
const StyledPrice = _styledComponents.default.p`
  font-size: 14px;
  color: ${props => props.primaryColor || '#262633'};
  font-weight: 400;
  margin: 0;

  ${_r10SourceLibrary.Mixins.respondTo.md(`font-size:18px; 
    font-weight: 600;
    & span {
      font-weight: 400;
    }
`)}
`;
const StyledPlanInfo = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
const CharacteristicsContainer = _styledComponents.default.div`
  margin: 10px 0px;
`;
const PlanDetailsWrapper = _styledComponents.default.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  ${_r10SourceLibrary.Mixins.respondTo.md(`gap: 60px;`)}
`;
const StyledPlanName = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  p {
    min-height: 26px;
  }
`;
const GridComparisonView = _ref => {
  let {
    displayedProducts
  } = _ref;
  const {
    products,
    showBusinessSolution,
    onProductSelect
  } = (0, _useComparison.default)();
  const primaryColor = (0, _useLocalTheme.default)('primaryColor', false);
  const comparisonCharacteristics = (0, _useConfig.default)('comparisonCharacteristics', []);
  const shouldRenderComparisonProductSelect = (0, _useConfig.default)('uiSettings.shouldRenderComparisonProductSelect', false);
  const additionalComparisonCharacteristics = (0, _useConfig.default)('additionalComparisonCharacteristics', []);
  const sharedServicesCharacteristics = (0, _useConfig.default)('sharedServicesCharacteristics', []);
  const market = (0, _useConfig.default)('market');
  const showLoadingIndicator = (0, _useConfig.default)('showLoadingIndicator', true);
  const isCheckoutEnabled = (0, _useConfig.default)('comparisonSettings.isCheckoutEnabled', false);
  const businessSolutions = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectRecommendationBusinessSolutions);
  const {
    isCheckoutInProgress,
    onNext
  } = (0, _useRecommendationActions.useRecommendationActions)();
  const [selectedProductId, setSelectedProductId] = (0, _react.useState)('');
  const metadata = (0, _useQuestionsMetadata.useQuestionsMetadata)();
  const handleNext = selectedProductId => {
    const selectedBusinessSolution = businessSolutions.find(businessSolutions => businessSolutions.productId === selectedProductId);
    setSelectedProductId(selectedProductId);
    onNext({
      selectedBusinessSolution
    });
  };
  const renderTabsText = product => {
    const {
      tier,
      productType
    } = product;
    const getTabText = () => {
      if (productType === 'plan') {
        var _TAP_TEXT_MAP$tier;
        return (_TAP_TEXT_MAP$tier = _constants.TAP_TEXT_MAP[tier]) !== null && _TAP_TEXT_MAP$tier !== void 0 ? _TAP_TEXT_MAP$tier : tier;
      }
      return tier;
    };
    return market === _constants.MARKETS_MAP.cl ? getTabText() : tier;
  };
  const renderHeader = () => {
    return /*#__PURE__*/_react.default.createElement(StyledContainerHeader, null, displayedProducts.map(productId => /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      dataAttributes: {
        'data-test-id': 'comparison-tab-title'
      },
      size: 2,
      key: productId
    }, _services.locale.localeString(`Recommendation.${renderTabsText(products[productId])}`))));
  };
  const renderCharacteristicRow = function (key, imageIcon, text, iconName) {
    let tabIndex = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(CharacteristicsContainer, {
      "data-test-id": `plan-feature-${tabIndex}`
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
      layout: {
        sm: [3, 9],
        md: [1, 11]
      },
      spacing: 1,
      key: key,
      verticalAlign: "center"
    }, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, _extends({}, iconName && {
      name: iconName,
      state: 'error'
    }, {
      src: {
        sm: imageIcon,
        md: imageIcon,
        lg: imageIcon
      },
      iconWidth: "24px",
      iconHeight: "24px"
    })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      size: 1
    }, text))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, {
      appearance: "secondary"
    }));
  };
  const checkSimilarity = (productId, selectedCharacteristic) => {
    var _products$otherProduc;
    const otherProduct = displayedProducts === null || displayedProducts === void 0 ? void 0 : displayedProducts.find(el => el !== productId);
    const otherProductCharacteristic = (_products$otherProduc = products[otherProduct].selectedVariant.characteristics) === null || _products$otherProduc === void 0 ? void 0 : _products$otherProduc.find(el => el.id === selectedCharacteristic.id);
    return (selectedCharacteristic === null || selectedCharacteristic === void 0 ? void 0 : selectedCharacteristic.valueText) === 'yes' && (otherProductCharacteristic === null || otherProductCharacteristic === void 0 ? void 0 : otherProductCharacteristic.valueText) === 'yes';
  };
  const handleHideDiscount = (termCostAfterDiscount, termCost) => {
    var _metadata$flags;
    //Refactor this function so it is based on the parser system
    const planPortLine = metadata === null || metadata === void 0 ? void 0 : (_metadata$flags = metadata.flags) === null || _metadata$flags === void 0 ? void 0 : _metadata$flags.planPortLine;
    return termCostAfterDiscount === termCost || !planPortLine && market === _constants.MARKETS_MAP.pe;
  };
  const getCharacteristics = function (product, comparisonCharacteristics) {
    let tabIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    const {
      termDuration,
      termCostAfterDiscount,
      termCost
    } = (0, _useRecommendationCosts.getCosts)(product.selectedVariant);
    const hideDiscountChar = handleHideDiscount(termCostAfterDiscount, termCost);
    return comparisonCharacteristics === null || comparisonCharacteristics === void 0 ? void 0 : comparisonCharacteristics.map(char => {
      if (char.key === 'DISCOUNT' && !hideDiscountChar) return renderCharacteristicRow(char.key, char.icon, _services.locale.localeString('Comparison.discountText', {
        amount: termDuration,
        price: _services.locale.formatPrice(termCost),
        pluralUnit: _services.locale.localeString('Recommendation.Month')
      }), char.iconName, tabIndex);
      const selectedCharacteristic = product.selectedVariant.characteristics.find(el => el.id === char.key);
      const shortDescription = (selectedCharacteristic === null || selectedCharacteristic === void 0 ? void 0 : selectedCharacteristic.shortDescription) || (selectedCharacteristic === null || selectedCharacteristic === void 0 ? void 0 : selectedCharacteristic.description);
      if (!shortDescription || _constants.COMPARISON_HIDDEN_VALUES.includes(selectedCharacteristic === null || selectedCharacteristic === void 0 ? void 0 : selectedCharacteristic.valueText) || checkSimilarity(product.productId, selectedCharacteristic)) return;
      return renderCharacteristicRow(char.key, char.icon, shortDescription, char.iconName, tabIndex);
    });
  };
  const getAdditionalCharacteristic = product => {
    if (product.tier === 'premium') {
      return additionalComparisonCharacteristics === null || additionalComparisonCharacteristics === void 0 ? void 0 : additionalComparisonCharacteristics.map(char => renderCharacteristicRow(char.key, char.icon, char.description, char.iconName));
    }
  };
  const getSharedServices = product => {
    const allDisplayedProductsAreSharedServices = displayedProducts.every(productId => products[productId].productName.includes(_constants.SHARED_SERVICES));
    if (product.productName.includes(_constants.SHARED_SERVICES) && !allDisplayedProductsAreSharedServices) {
      return sharedServicesCharacteristics === null || sharedServicesCharacteristics === void 0 ? void 0 : sharedServicesCharacteristics.map(char => renderCharacteristicRow(char.key, char.icon, char.description, char.iconName));
    }
  };
  const renderPlanDetails = () => {
    const planIdWithDifferentHeader = (0, _useConfig.default)('planIdWithDifferentHeader', []);
    const showFullPlanName = (0, _useConfig.default)('showFullPlanName', true);
    return /*#__PURE__*/_react.default.createElement(PlanDetailsWrapper, null, displayedProducts.map((productId, index) => {
      const product = products[productId];
      const {
        termCost,
        termCostAfterDiscount
      } = (0, _useRecommendationCosts.getCosts)(product.selectedVariant);
      const hideDiscount = handleHideDiscount(termCostAfterDiscount, termCost);
      return /*#__PURE__*/_react.default.createElement(PlanTitleContainer, {
        key: productId
      }, /*#__PURE__*/_react.default.createElement(StyledPlanName, {
        "data-test-id": `plan-title-${index}`
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
        size: 2,
        noMargin: true
      }, new _services.Parsers.ComparisonParser().comparisonPlanName(planIdWithDifferentHeader.some(text => text.includes(productId.split('-')[0])))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
        spacingLevel: {
          right: 2
        }
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
        size: 2,
        weight: 3,
        noMargin: true
      }, showFullPlanName ? product.productName : product.productName.split('Plan')[1]))), /*#__PURE__*/_react.default.createElement(StyledPrice, {
        "data-test-id": `plan-price-${index}`,
        size: 2,
        noMargin: true,
        primaryColor: primaryColor
      }, `${_services.locale.formatPrice(termCostAfterDiscount && !hideDiscount ? termCostAfterDiscount : termCost)}`, /*#__PURE__*/_react.default.createElement("span", null, `/${_services.locale.localeString('Comparison.RecurringDuration')}`)), shouldRenderComparisonProductSelect && /*#__PURE__*/_react.default.createElement(CenteringWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
        appearance: "primary",
        text: _services.locale.localeString('Comparison.ButtonText'),
        width: "full",
        loading: isCheckoutInProgress && selectedProductId === productId && showLoadingIndicator,
        state: isCheckoutInProgress ? 'disabled' : '',
        onClick: () => isCheckoutEnabled ? !isCheckoutInProgress && handleNext(productId) : onProductSelect(productId)
      })));
    }));
  };
  //--------Market Place refinement---------------
  const commonSpecs = [],
    differentSpecs = [];
  let sortedCharacteristics = [...comparisonCharacteristics];
  if (market === _constants.MARKETS_MAP.maac_ie) {
    Object.values(products).forEach(product => {
      product.selectedVariant.characteristics.forEach(characteristic => {
        const indexOfSpec = differentSpecs.indexOf(characteristic.name);
        if (indexOfSpec > -1) {
          differentSpecs.splice(indexOfSpec, 1);
          commonSpecs.push(characteristic.name);
        } else if (characteristic.valueText === 'yes') {
          differentSpecs.push(characteristic.name);
        }
      });
    });
  }
  sortedCharacteristics = sortedCharacteristics.sort((char1, char2) => {
    return commonSpecs.includes(char1.key) ? commonSpecs.includes(char2.key) ? comparisonCharacteristics.indexOf(char2.key) - comparisonCharacteristics.indexOf(char1.key) : -1 : 1;
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Container, null, renderHeader(), renderPlanDetails(), /*#__PURE__*/_react.default.createElement(StyledContainerBody, {
    id: "comparison-container-body"
  }, displayedProducts.map((productId, tabIndex) => {
    return /*#__PURE__*/_react.default.createElement(StyledPlanInfo, {
      key: productId
    }, getCharacteristics(products[productId], sortedCharacteristics, tabIndex), showBusinessSolution && getAdditionalCharacteristic(products[productId]), getSharedServices(products[productId]));
  }))));
};
var _default = GridComparisonView;
exports.default = _default;